// Debugging confirmation
console.log('✅ router-navigator.js loaded successfully!');

import { loadPageFromURL } from './router.js';
import { clearAllListenersFromCurrentlyAttachedListenersRegistry } from './currently-attached-listener-registry.js';

/**
 * Set up navigation for the application
 */
export async function setupNavigationForApp() {
  console.log('🔧 Setting up navigation...');

  // Intercept all link clicks
  document.body.addEventListener('click', async event => {
    const target = event.target.closest('a');

    // Ignore if not a valid internal link
    if (!target || target.hostname !== window.location.hostname) return;

    event.preventDefault(); // Prevent full reload

    const newUrl = target.href;
    console.log(`🔗 Navigating to: ${newUrl}`);

    await navigateTo(newUrl);
  });

  // Handle browser back/forward button navigation
  window.addEventListener('popstate', async () => {
    console.log('🔄 Browser navigation detected (back/forward)');
    await loadPageFromURL();
  });

  console.log('✅ Navigation setup completed.');
}

/**
 * Navigate to the specified URL without refreshing the page
 * @param {string} url - The destination URL
 */
export async function navigateTo(url) {
  try {
    clearAllListenersFromCurrentlyAttachedListenersRegistry();

    console.log(`🔗 Navigating to URL: ${url}`);
    history.pushState({}, '', url); // Update URL without page reload
    await loadPageFromURL(); // Dynamically load the page content
    console.log('✅ Page loaded dynamically.');
  } catch (error) {
    console.error('❌ Error during navigation:', error);
  }
}
